(() => {
  const confirmationMarker = 'subscription-confirmed';

  const showConfirmationDialog = () => {
    if (document.querySelector('[data-dr-subscription-dialog]')) return;

    const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
    const copy = isFrench
      ? {
          kicker: 'DESERT ROSE / LISTE PRIVÉE',
          title: 'INSCRIPTION CONFIRMÉE',
          body: 'Votre adresse e-mail est confirmée. Vous faites désormais partie de la liste privée Desert Rose.',
          close: 'CONTINUER'
        }
      : {
          kicker: 'DESERT ROSE / PRIVATE LIST',
          title: 'SUBSCRIPTION CONFIRMED',
          body: 'Your email address is confirmed. You are now on the Desert Rose private list.',
          close: 'CONTINUE'
        };

    const dialog = document.createElement('dialog');
    dialog.className = 'dr-subscription-dialog';
    dialog.dataset.drSubscriptionDialog = '';
    dialog.setAttribute('aria-labelledby', 'DrSubscriptionTitle');
    dialog.setAttribute('aria-describedby', 'DrSubscriptionText');

    const panel = document.createElement('div');
    panel.className = 'dr-subscription-dialog__panel';
    const kicker = document.createElement('span');
    kicker.className = 'dr-subscription-dialog__kicker';
    kicker.textContent = copy.kicker;
    const title = document.createElement('strong');
    title.className = 'dr-subscription-dialog__title';
    title.id = 'DrSubscriptionTitle';
    title.textContent = copy.title;
    const body = document.createElement('p');
    body.id = 'DrSubscriptionText';
    body.textContent = copy.body;
    const close = document.createElement('button');
    close.className = 'dr-subscription-dialog__close';
    close.type = 'button';
    close.textContent = copy.close;

    const closeDialog = () => {
      if (typeof dialog.close === 'function' && dialog.open) dialog.close();
      else {
        dialog.removeAttribute('open');
        dialog.remove();
      }
    };
    close.addEventListener('click', closeDialog);
    dialog.addEventListener('click', event => { if (event.target === dialog) closeDialog(); });
    dialog.addEventListener('close', () => dialog.remove(), {once: true});

    panel.append(kicker, title, body, close);
    dialog.append(panel);
    document.body.append(dialog);

    const open = () => {
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    };
    const waitForLoader = () => {
      if (!document.documentElement.classList.contains('dr-entry-pending')) open();
      else window.setTimeout(waitForLoader, 100);
    };
    waitForLoader();
  };

  const personalizeSubscriptionPage = () => {
    const url = new URL(window.location.href);
    const hasConfirmationMarker = url.hash === `#${confirmationMarker}` || url.searchParams.get('dr_subscription') === 'confirmed';

    if (hasConfirmationMarker) {
      url.hash = '';
      url.searchParams.delete('dr_subscription');
      window.history.replaceState({}, '', `${url.pathname}${url.search}`);
      showConfirmationDialog();
      return;
    }

    if (!window.location.pathname.includes('/account/subscribe')) return;

    const main = document.getElementById('MainContent');
    if (!main || main.querySelector('[data-dr-subscription-system]')) return;

    const isFrench = (document.documentElement.lang || '').toLowerCase().startsWith('fr');
    const copy = isFrench
      ? {
          kicker: 'DESERT ROSE / CONFIRMATION',
          title: 'ACCÈS CONFIRMÉ',
          body: 'Votre inscription à la liste privée Desert Rose est confirmée.',
          note: 'Vous gardez le contrôle et pouvez vous désinscrire à tout moment.',
          unsubscribe: 'SE DÉSINSCRIRE',
          home: 'REVENIR À L’ACCUEIL',
          documentTitle: 'Accès confirmé — Desert Rose'
        }
      : {
          kicker: 'DESERT ROSE / CONFIRMATION',
          title: 'ACCESS CONFIRMED',
          body: 'Your place on the Desert Rose private list is confirmed.',
          note: 'You remain in control and can unsubscribe at any time.',
          unsubscribe: 'UNSUBSCRIBE',
          home: 'RETURN HOME',
          documentTitle: 'Access confirmed — Desert Rose'
        };

    const currentNodes = Array.from(main.childNodes);
    const section = document.createElement('section');
    const inner = document.createElement('div');
    const kicker = document.createElement('p');
    const systemContent = document.createElement('div');
    const homeLink = document.createElement('a');

    section.className = 'dr-subscription-confirmation';
    inner.className = 'dr-subscription-confirmation__inner';
    kicker.className = 'dr-subscription-confirmation__kicker';
    kicker.textContent = copy.kicker;
    systemContent.className = 'dr-subscription-confirmation__system';
    systemContent.dataset.drSubscriptionSystem = '';
    currentNodes.forEach((node) => systemContent.appendChild(node));

    const segments = window.location.pathname.split('/').filter(Boolean);
    const localePrefix = segments[0] && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(segments[0]) ? `/${segments[0]}` : '';
    homeLink.className = 'dr-subscription-confirmation__home';
    homeLink.href = `${localePrefix}/`;
    homeLink.textContent = `${copy.home} ↗︎`;

    inner.append(kicker, systemContent, homeLink);
    section.append(inner);
    main.append(section);

    const heading = systemContent.querySelector('h1, h2');
    const paragraphs = Array.from(systemContent.querySelectorAll('p')).filter((element) => element.textContent.trim());
    const links = Array.from(systemContent.querySelectorAll('a[href]'));
    const unsubscribeLink = links[links.length - 1];

    if (heading) heading.textContent = copy.title;
    if (paragraphs[0]) paragraphs[0].textContent = copy.body;
    if (paragraphs[1]) paragraphs[1].textContent = copy.note;

    if (unsubscribeLink) {
      unsubscribeLink.textContent = copy.unsubscribe;
      unsubscribeLink.classList.add('dr-subscription-confirmation__unsubscribe');
      homeLink.insertAdjacentElement('afterend', unsubscribeLink);
    }

    document.documentElement.classList.add('dr-subscription-ready');
    document.title = copy.documentTitle;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', personalizeSubscriptionPage, { once: true });
  } else {
    personalizeSubscriptionPage();
  }
})();
